import Header from "../components/Header";
import Footer from "../components/Footer";
import BottomTabBar from "../components/BottomTabBar";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function About() {
  return (
    <div className="warm-bg min-h-screen">
      <Header />
      <main className="max-w-3xl mx-auto px-6 pt-12 pb-16 relative z-10">
        {/* Hero */}
        <motion.div
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45 }}
        >
          <span
            className="inline-block text-[10px] font-extrabold tracking-[0.3em] uppercase text-[#FF4D8D] mb-3"
            data-testid="about-eyebrow"
          >
            How it works
          </span>
          <h1
            className="font-display italic text-4xl sm:text-5xl text-white leading-[1.05] mb-3"
            data-testid="about-hero"
          >
            A game for two.
          </h1>
          <p className="text-base text-[#C9C7D9] mb-10">
            VibeCheck is a couples game that turns flirty curiosity, cute trivia,
            and emotional honesty into a 5-minute date you actually want to play.
          </p>
        </motion.div>

        {/* 4-step flow */}
        <ol className="space-y-3 mb-12" data-testid="about-steps">
          <Step n={1} title="Create a room" body="One tap, one room code." />
          <Step
            n={2}
            title="Share the code"
            body="WhatsApp, iMessage, in-person — whatever's easiest."
          />
          <Step
            n={3}
            title="Play together"
            body="Truth, dare, partner quiz, or date-night missions. AI keeps every round fresh."
          />
          <Step
            n={4}
            title="Unlock premium packs"
            body="Spicier questions, mini missions, and the bundle that unlocks everything."
          />
        </ol>

        {/* Why it's different */}
        <h2 className="font-display italic text-2xl sm:text-3xl text-white mb-4">
          Built for the way couples actually play.
        </h2>
        <ul className="space-y-2 text-[#C9C7D9] text-sm mb-10 list-none pl-0">
          <Bullet>1,400+ handcrafted prompts across 15 packs.</Bullet>
          <Bullet>AI personalises new questions every 4th round so it never feels stale.</Bullet>
          <Bullet>Voice notes &amp; view-once video dares — vanish after one play.</Bullet>
          <Bullet>Connection score on the share card (Chemistry · Chaos · Soulmate · Toxic).</Bullet>
          <Bullet>No accounts required to play. Sign up only if you want to keep history or unlocks.</Bullet>
        </ul>

        {/* CTA */}
        <div className="flex flex-col sm:flex-row gap-3 mb-10">
          <Link
            to="/"
            className="btn-gradient rounded-full px-6 py-3 font-bold text-white text-center active:scale-95"
            data-testid="about-cta-play"
          >
            Start a room
          </Link>
          <Link
            to="/pricing"
            className="rounded-full px-6 py-3 font-bold text-white text-center border border-white/15 hover:bg-white/5 transition-colors"
            data-testid="about-cta-pricing"
          >
            See what's in Premium
          </Link>
        </div>

        {/* 18+ disclaimer */}
        <div
          className="rounded-2xl border border-[#FF4D8D]/30 bg-[#FF4D8D]/5 p-4 text-sm text-[#C9C7D9]"
          data-testid="about-age-notice"
        >
          <span className="text-[10px] font-extrabold tracking-[0.3em] mr-2 px-2 py-0.5 rounded-md bg-[#FF4D8D]/15 border border-[#FF4D8D]/40 text-[#FF4D8D]">
            18+
          </span>
          VibeCheck is intended for adults. Some packs include mature content — by
          using the app you confirm you are 18 or over.
        </div>
      </main>
      <Footer />
      <BottomTabBar />
    </div>
  );
}

function Step({ n, title, body }) {
  return (
    <li className="flex items-start gap-4 rounded-2xl border border-white/8 bg-white/3 p-4">
      <span className="flex-shrink-0 w-9 h-9 rounded-xl bg-gradient-to-br from-[#FF4D8D] to-[#7B61FF] text-white font-display-tight text-lg font-bold inline-flex items-center justify-center shadow-[0_0_18px_rgba(255,77,141,0.4)]">
        {n}
      </span>
      <div>
        <div className="text-white font-bold text-base mb-0.5">{title}</div>
        <div className="text-sm text-[#C9C7D9]">{body}</div>
      </div>
    </li>
  );
}

function Bullet({ children }) {
  return (
    <li className="flex items-start gap-2">
      <span className="text-[#FF4D8D] font-bold">·</span>
      <span>{children}</span>
    </li>
  );
}
